export const CREDIT_RESTORATION_SCORE_AVERAGE_INCREASE = 80;
export const CREDIT_RESTORATION_SCORE_MAX = 850;
